import AICreateIcon from "@/components/icons/AICreateIcon";
import WhiteLogo from "@/components/icons/WhiteLogo";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card, CardContent, CardFooter, CardTitle } from "@/components/ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselDots,
  CarouselItem,
} from "@/components/ui/carousel";
import { Star } from "lucide-react";
import { testimonials } from "./testimonials";
import Autoplay from "embla-carousel-autoplay";

const Step1ContentPreview = () => {
  return (
    <div className="bg-primary lg:rounded-[20px] shadow-md p-6 lg:p-10 text-white flex flex-col justify-between lg:max-w-[98vw] h-[calc(100%-0.5rem)] object-cover lg:mt-1">
      <WhiteLogo />
      <div className="flex flex-col gap-3 px-1 mt-6 lg:mt-0">
        <h1 className="text-4xl font-bold">Launch AI Apps with Ease</h1>
        <p>
          No coding required. Just a few clicks to create powerful AI-driven app
        </p>
      </div>

      <div className="mx-auto">
        <AICreateIcon width="100%" />
      </div>

      {testimonials && <Carousel
        opts={{
          align: "start",
          loop: true,
          active: true,
        }}
        plugins={[
          Autoplay({
            delay: 5000,
          }),
        ]}
      >
        <CarouselContent>
          {testimonials?.map((data, index) => (
            <CarouselItem key={data.name + index}>
              <Card className="!bg-[#3D82FE] text-white border-none p-5 flex flex-col gap-4 mx-1 min-h-48">
                <CardTitle className="text-xl/[24px]">{data.title}</CardTitle>
                <CardContent className="flex items-center justify-center p-0 text-[#e6efff]">
                  {data.review}
                </CardContent>
                <CardFooter className="p-0">
                  <div className="flex gap-2 items-center w-full">
                    <Avatar>
                      <AvatarImage
                        src={data.image}
                        alt="logo"
                        className="object-cover o bg-white"
                      />
                      <AvatarFallback>{"LOGO"}</AvatarFallback>
                    </Avatar>
                    <p>{data.name}</p>
                    <div className="flex ml-auto">
                      {[...Array(data.rating)].map(() => (
                        <Star fill="#FFC787" stroke="#FFC787" />
                      ))}
                    </div>
                  </div>
                </CardFooter>
              </Card>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselDots />
      </Carousel>}
    </div>
  );
};

export default Step1ContentPreview;
